export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1679391029864-d46f366a456b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  football: "https://images.unsplash.com/photo-1517927033932-b3d18e61fb3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  basketball: "https://images.unsplash.com/photo-1719521178357-64ac2316f0ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  rosterBanner: "https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  contactBanner: "https://images.unsplash.com/photo-1671723204288-1b3794effd87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  partnersBanner: "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
};

export const CREST = "/crest.webp";
